import '../../assets/css/login.css';
import React from 'react';

import AuthTemplate from './AuthTemplate';
import { RouteEnums } from '@Helper/Enums';
import { useNavigate } from 'react-router';

const UserRegistered = () => {
  let navigate = useNavigate();
  React.useEffect(() => {
    setTimeout(() => {
      navigate(`${RouteEnums.Login}`);
    }, 1500);
  }, []);
  return (
    <AuthTemplate headerText="Welcome to Mergeflo">
      <div className="login_inputs">
        <div className="enter_your_mail">
          Your confirmation is completed you'll redirect to login page soon. If
          you have any difficulties in redirection, you can click to the
          <span
            className="info_text"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigate(`${RouteEnums.Login}`);
            }}
          >
            {' '}
            login{' '}
          </span>
          page.
        </div>
      </div>
    </AuthTemplate>
  );
};
export default UserRegistered;
